import { ReactNode } from 'react';

import { ExamplesGroup } from '@/types/schema';
import { cn } from '@/utils/tailwind';

import { ExperimentColumnHeader } from '../SingleExperimentColumns/ExperimentColumnHeader';
import { AggregatedStatHeader } from './AggregatedStatHeader';

export const SingleGroupMetricsColumnHeader = ({
  startingIndex,
  tableHeight,
  columnWidthStorage,
  setColumnWidthStorage,

  metric,

  className,
  group,
  isTable = true,
}: {
  startingIndex: number;
  tableHeight: number;
  columnWidthStorage: number[];
  setColumnWidthStorage: (fromPrev: (prev: number[]) => number[]) => void;
  metric: {
    name: string;
    minWidth: number;
  };

  className?: string;
  group: ExamplesGroup;
  isTable?: boolean;
}) => {
  let content: ReactNode = null;
  switch (metric.name) {
    case 'latency':
      content = (
        <AggregatedStatHeader
          stat={group.latency_p50}
          type="AVG"
          tooltip={
            <div>
              <pre>P50: {group.latency_p50}s</pre>
              <pre>P99: {group.latency_p99}s</pre>
            </div>
          }
        />
      );
      break;
    case 'tokens':
      content = <AggregatedStatHeader stat={group.total_tokens} type="TOTAL" />;
      break;
    case 'cost':
      content = <AggregatedStatHeader stat={group.total_cost} type="TOTAL" />;
      break;
    default:
      content = null;
  }

  return (
    <ExperimentColumnHeader
      key={metric.name}
      columnIndex={startingIndex}
      columnName={metric.name}
      columnWidthStorage={columnWidthStorage}
      setColumnWidthStorage={setColumnWidthStorage}
      tableHeight={tableHeight}
      minColumnWidth={metric.minWidth}
      className={cn('flex items-center', className)}
      isTable={isTable}
    >
      {content}
    </ExperimentColumnHeader>
  );
};
